<template>
  <td>
    <div class="btn-group">
      <v-button
        :request="setPublic"
        class="btn btn-success"
        :disabled="model.is_erotic"
      >
        <i class="fas fa-check"></i> 18>
      </v-button>
      <v-button
        :request="setErotic"
        class="btn btn-warning"
        :disabled="model.is_public"
      >
        <i class="fas fa-globe"></i> 18+
      </v-button>
      <v-button :request="destroy" class="btn btn-danger">
        <i class="fas fa-trash"></i> löschen
      </v-button>
    </div>
  </td>
</template>

<script lang="babel">
export default {
    props: ['model', "hideFast"],
    methods: {
      setPublic () {
        if(this.hideFast) {
          this.$emit('removeModel')
        }
        this.$emit("action", "public");
      },
      setErotic() {
        if(this.hideFast) {
          this.$emit('removeModel')
        }
        this.$emit("action", "erotic");
      },
      destroy() {
        this.$emit('removeModel')
        this.$emit("action", "delete");
      },
    }
};
</script>
